var dependencies = {};
export var setDeps = function setDeps(deps) {
  dependencies = Object.assign({}, dependencies, deps);
  return dependencies;
};
export var getDeps = function getDeps() {
  return dependencies;
};